@if (isAdmin()) {
  <app-admin-reports />
} @else {
  @if (finishedOnboarding()) {
    <app-dashboard />
  } @else {
    <app-onboarding />
  }
}
